import React from "react";
import {
  Flex,
  Heading,
  Text,
  Skeleton,
  IconButton,
} from "@chakra-ui/react";
import { IconClose } from "components/icons/Icons";
import UserInfoMenu from "components/menu/UserInfoMenu";
import { pad_with_zeroes } from "network/helper";

interface ProjectHeaderProps {
  selectedProject: any;
  isFetching: boolean;
  hasChanged: boolean;
  onCloseModal: Function;
  onRefresh?: Function;
}

export const ProjectHeader: React.FC<ProjectHeaderProps> = ({
  selectedProject,
  isFetching,
  hasChanged,
  onCloseModal,
  onRefresh,
}) => {
  const handleClose = () => {
    if (hasChanged) {
      onRefresh?.();
    }
    onCloseModal();
  };

  return (
    <>
      <IconButton
        onClick={handleClose}
        aria-label="close"
        minW={"unset"}
        h={{ md: "52px", sm: "32px" }}
        w={{ md: "52px", sm: "32px" }}
        borderRadius="50%"
        bg="inherit"
        marginRight={{ md: "60px", sm: "0px", base: "0px" }}
        position={{ md: "unset", sm: "absolute", base: "absolute" }}
        right={{ md: "unset", sm: "30px", base: "30px" }}
        top={{ md: "unset", sm: "10px", base: "10px" }}
        _active={{
          bg: "inherit",
          transform: "none",
          borderColor: "transparent",
        }}
        _focus={{
          boxShadow: "none",
        }}
        icon={
          <IconClose
            h={{ md: "52px", sm: "32px" }}
            w={{ md: "52px", sm: "32px" }}
          />
        }
      />

      <Flex justifyContent="space-between">
        <Flex
          alignItems="center"
          flexWrap="wrap"
          columnGap={{ md: "60px", sm: "20px" }}
        >
          <Heading
            fontSize="25px"
            lineHeight="135%"
            fontWeight="400"
            color="#000"
          >
            {isFetching ? (
              <Skeleton height="34px" width="100px"></Skeleton>
            ) : (
              pad_with_zeroes(selectedProject?.order?.order_id, 6) ||
              "undefined"
            )}
          </Heading>
          <Flex alignItems="center">
            <Text
              fontSize="14px"
              lineHeight="135%"
              fontWeight="400"
              color="#000"
            >
              ID:
            </Text>
            {isFetching ? (
              <Skeleton height="25px" width="70px" />
            ) : (
              <Text color="#8E8C8C" marginLeft="10px">
                {pad_with_zeroes(selectedProject?.order?.order_id, 6)}
              </Text>
            )}
          </Flex>
        </Flex>
        <UserInfoMenu />
      </Flex>
    </>
  );
};
